import { CurrencyCode } from "./localesConfig";

/**
 * Manual USD→local FX rates for quote display.
 * Update periodically; invoices can still be issued in local currency.
 * Rates approximate as of 2026-03 planning baseline.
 */
export const USD_TO_LOCAL: Record<CurrencyCode, number> = {
  USD: 1,
  EUR: 0.92,
  MXN: 17.1,
  CAD: 1.36,
  GBP: 0.79,
};

export const convertFromUsd = (
  amountUsd: number,
  currency: CurrencyCode
): number => amountUsd * USD_TO_LOCAL[currency];

export const formatMoney = (
  amount: number,
  currency: CurrencyCode,
  localeTag: string
): string =>
  new Intl.NumberFormat(localeTag, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(amount);

export const formatUsdAndLocal = (
  amountUsd: number,
  currency: CurrencyCode,
  localeTag: string
): { usd: string; local: string; localAmount: number } => {
  const localAmount = convertFromUsd(amountUsd, currency);
  return {
    usd: formatMoney(amountUsd, "USD", "en-US"),
    local: formatMoney(localAmount, currency, localeTag),
    localAmount,
  };
};
